export const ALIGN = {
  center: "center",
  left: "left",
  right: "right",
}
